// Generated by scripts/brand.js for client "mevis". Do not edit; change src/clients/mevis/ instead.
import brand from '../clients/mevis/brand.json'
import logo from '../clients/mevis/logo.png'
import hero from '../clients/mevis/hero.jpg'

export const tokens = {
    "--color-primary": "#76046b",
    "--color-primary-hover": "#5e0355",
    "--color-primary-soft": "#f6e8f4",
    "--color-on-primary": "#ffffff",
    "--color-accent": "#f5b812",
    "--color-accent-soft": "#fff6dc",
    "--color-on-accent": "#1f1f1f",
    "--color-highlight": "#13e6b1",
    "--color-highlight-soft": "#e3fbf4",
    "--color-tint": "#fde7ef",
    "--shadow-primary": "0 6px 16px rgba(118, 4, 107, 0.25)",
    "--font-display": "\"Baloo 2\", \"Nunito\", system-ui, sans-serif",
    "--font-body": "\"Nunito\", system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif",
    "--radius-sm": "8px",
    "--radius-md": "14px",
    "--radius-lg": "20px",
    "--radius-pill": "999px"
}

const active = { ...brand, logo, heroImage: hero }
export default active
